import React from 'react';
import { useTranslation } from '../App';

const Projects = () => {
  const t = useTranslation();
  const projects = [
    { id: 1, bg: 'url(/assets/s1.jpeg)' },
    { id: 2, bg: 'url(/assets/s3.jpeg)' },
    { id: 3, bg: 'url(/assets/p1.jpeg)' },
    { id: 4, bg: 'url(https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&h=500&fit=crop)' },
    { id: 5, bg: 'url(/assets/p3.jpeg)' },
    { id: 6, bg: 'url(/assets/p4.jpeg)' },
    { id: 7, bg: 'url(https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=400&h=500&fit=crop)' },
    { id: 8, bg: 'url(https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=400&h=500&fit=crop)' },
    { id: 9, bg: 'url(https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=400&h=500&fit=crop)' }
  ];

  return (
    <section className="proj" id="project">
      <div className="service-content proj-content flex">
        <div>
          <span>{t.projects.title}</span>
          <h3>{t.projects.heading}</h3>
        </div>
        <div>
          <p>{t.projects.description}</p>
        </div>
      </div>

      <section id="horizontal-scoll">
        <div className="horizontal-scoll-wrapper">
          <div className="horizontal">
            {projects.map((project) => (
              <div key={project.id} className={`card${project.id}`}>
                <div className="card" style={{ backgroundImage: project.bg, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
};

export default Projects;